import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { PrimaryButton } from "components/Button/style";
import { converterDataHoraBr } from "_utils/Data";
import { IImpressaoEtiqueta, StatusImpressao } from "../../interfaces/IImpressaoEtiqueta";
import { Container, Header, Tag, TextoHeader } from "./style";

const statusLabel: Record<StatusImpressao, string> = {
  PENDENTE: "Pendente",
  IMPRIMINDO: "Imprimindo",
  IMPRESSO: "Impresso",
  ERRO: "Erro",
};

interface IListarProps {
  registros: IImpressaoEtiqueta[];
  loading: boolean;
  impressoraConectada: boolean;
  onReimprimir: (idProcesso: string) => void;
}

export function Listar({ registros, loading, impressoraConectada, onReimprimir }: IListarProps) {
  const columns: IColum<IImpressaoEtiqueta>[] = [
    {
      name: <span>ID Processo</span>,
      selector: ({ idProcesso }: IImpressaoEtiqueta) => idProcesso,
      width: "130px",
    },
    {
      name: <span>Placa</span>,
      selector: ({ placa }: IImpressaoEtiqueta) => placa ?? "-",
      width: "110px",
    },
    {
      name: <span>Status</span>,
      selector: ({ status }: IImpressaoEtiqueta) => (
        <Tag tipo={status}>{statusLabel[status]}</Tag>
      ),
      width: "130px",
    },
    {
      name: <span>Tentativas</span>,
      selector: ({ tentativas }: IImpressaoEtiqueta) => tentativas,
      width: "110px",
    },
    {
      name: <span>Criado em</span>,
      selector: ({ criadoEm }: IImpressaoEtiqueta) =>
        criadoEm ? converterDataHoraBr(criadoEm) : "-",
      width: "170px",
    },
    {
      name: <span>Mensagem de Erro</span>,
      selector: ({ mensagemErro }: IImpressaoEtiqueta) => mensagemErro ?? "-",
    },
    {
      name: <span>Ações</span>,
      selector: ({ idProcesso }: IImpressaoEtiqueta) => (
        <PrimaryButton
          outline
          variante="primary"
          buttonWidth="sm"
          buttonWidthTipo="px"
          disabled={!impressoraConectada}
          onClick={() => onReimprimir(idProcesso)}
        >
          Reimprimir
        </PrimaryButton>
      ),
      width: "120px",
    },
  ];

  return (
    <Container>
      <Header>
        <TextoHeader>Listagem de registros</TextoHeader>
      </Header>
      <hr />
      <Table
        keyField="id"
        columns={columns}
        data={registros}
        loading={loading}
        pagination={false}
        noSubHeader
      />
    </Container>
  );
}
